/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FeesResponse
 */
export interface FeesResponse {
  /**
   *
   * @type {number}
   * @memberof FeesResponse
   */
  claimFee?: number
}

export function FeesResponseFromJSON(json: any): FeesResponse {
  return FeesResponseFromJSONTyped(json, false)
}

export function FeesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    claimFee: !exists(json, 'claimFee') ? undefined : json['claimFee'],
  }
}

export function FeesResponseToJSON(value?: FeesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    claimFee: value.claimFee,
  }
}
